export default __webpack_public_path__ + "static/media/prashant_cartoon.708ab314.png";